// @flow

import {VerticalPositionElement} from './constants';

import type {VerticalPositionElementType} from './typedef';


type GetOffsetTop = (
    height: number,
    vertical: VerticalPositionElementType,
    isFlip: boolean,
) => number;

/**
* Utility that calculates the vertical offset.
* @param {number} height - Container height.
* @param {VerticalPositionElementType} vertical - To which point is the position vertically attached.
* @param {boolean} isFlip - Is the container inverted.
* @returns {number}
 * @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export const getOffsetTop: GetOffsetTop = (height, vertical, isFlip) => {
    let offset = 0;

    if (typeof vertical === 'number') {
        offset = vertical;
    } else if (vertical === VerticalPositionElement.CENTER) {
        offset = height / 2;
    } else if (vertical === VerticalPositionElement.BOTTOM && !isFlip) {
        offset = height;
    } else if (vertical === VerticalPositionElement.TOP && isFlip) {
        offset = height;
    }

    return offset;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
